import { memo, type ReactNode, useCallback } from 'react';

import { cn } from '@air/utils-tailwind';

export type WorkspaceSidebarCollapsibleProps = {
  children: ReactNode;
  open: boolean;
};

/**
 * grid-template-rows 0fr → 1fr animates the block's height so the rest of the
 * side nav slides with it. Children stay mounted; the closed row is inert.
 */
export const WorkspaceSidebarCollapsible = memo(({ children, open }: WorkspaceSidebarCollapsibleProps) => {
  const setContentElement = useCallback(
    (node: HTMLDivElement | null) => {
      if (node) {
        node.inert = !open;
      }
    },
    [open],
  );

  return (
    <div
      className={cn(
        'grid transition-[grid-template-rows] duration-200 ease-out',
        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
      )}
    >
      <div className="min-h-0 overflow-hidden" ref={setContentElement}>
        {children}
      </div>
    </div>
  );
});

WorkspaceSidebarCollapsible.displayName = 'WorkspaceSidebarCollapsible';
